import React, {useEffect, useState} from 'react';
import {Line} from '@ant-design/plots';
import {useSelector} from 'react-redux';
import {Spin, Alert, Card, Button, Tooltip} from 'antd';
import {FileExcelFilled} from '@ant-design/icons';
import * as XLSX from 'xlsx';
import {useGetManagerReportQuery} from "../../../../../slices/rootApiSlices/reportApiSlice";

const AverageFuelUsed = () => {
    const {user} = useSelector((state) => state.auth);
    const [chartData, setChartData] = useState([]);
    const {data: apiData, isLoading, error} = useGetManagerReportQuery(user?.token);

    useEffect(() => {
        if (apiData?.data) {
            const formattedData = apiData.data
                .map(item => ({
                    Date: new Date(item.result_date).toLocaleString(), // Tarih ve Saat
                    FuelUsed: parseFloat(item.daily_avg_fuel_used) || 0, // Yakıt Tüketimi
                }))
                .filter(data => data.FuelUsed !== 0); // 0 olan verileri filtreleme

            setChartData(formattedData);
        }
    }, [apiData]);

    const handleDownload = () => {
        const title = 'Ortalama_Yakit_Tuketimi_Raporu';
        const workbook = XLSX.utils.book_new();

        // Excel verisi hazırlanıyor
        const worksheetData = [
            ['Rapor Tipi:', 'Günlük Ortalama Yakıt Tüketimi Raporu'], // Başlık
            ['Rapor Oluşturma Tarihi:', new Date().toLocaleString()], // Tarih ve Saat
            ['Raporu Oluşturan:', user?.name || 'Bilinmiyor'], // Kullanıcı Bilgisi
            [], // Boş Satır
            ['Tarih', 'Yakıt Tüketimi [L]'], // Tablo Başlıkları
            ...chartData.map(data => [data.Date, data.FuelUsed]) // Tarih ve Yakıt Verisi
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Sütun genişliği ayarlanıyor
        const maxWidths = worksheetData[0].map((_, colIndex) =>
            Math.max(...worksheetData.map(row => (row[colIndex]?.toString().length || 0)))
        );
        worksheet['!cols'] = maxWidths.map(width => ({width}));

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Ortalama Yakıt Tüketimi Raporu');

        // Excel dosyasını kaydetme
        XLSX.writeFile(workbook, `${title}.xlsx`);
    };

    if (isLoading) {
        return <Spin style={{display: 'block', margin: 'auto', marginTop: '20%'}}/>;
    }

    if (error) {
        return <Alert message="Veri yüklenirken bir hata oluştu." type="error"/>;
    }

    const config = {
        data: chartData,
        padding: 'auto',
        xField: 'Date',
        yField: 'FuelUsed',
        xAxis: {
            tickCount: 5,
        },
        slider: {
            start: 0.1,
            end: 0.5,
        },
    };

    return (
        <Card
            type="inner"
            size="small"
            style={{marginBottom: 10}}
            title="Günlük Ortalama Yakıt Tüketimi"
            extra={
                <Tooltip title="Rapor olarak indir">
                    <Button
                        type="text"
                        icon={<FileExcelFilled/>}
                        onClick={handleDownload}
                    />
                </Tooltip>
            }
        >
            <Line {...config} style={{height: 355}}/>
        </Card>
    );
};

export default AverageFuelUsed;
